import React from "react";
import clsx from "clsx";
import { Grid } from "@mui/material";
import { Box, Button, Card, Chip, Divider, Stack, Typography } from "@curves/ui-base";

import { ReadTextField } from "@Local/Components";
import InvoiceAllowanceCard from "@Local/Orders/OrderViewPage/Components/InvoiceAllowanceCard";
import { isEmpty, isEqual, isFunction } from "@Util/utils";
import { ORDER_STATUS_COLOR_MATCH } from "@Constants/appConfig";
/**
 * 訂單發票資訊區塊組件
 *
 * 功能：
 * - 顯示訂單相關的發票資訊
 * - 包含發票狀態、號碼、折讓等資訊
 * - 支援折讓操作功能
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Object} props.paymentData - 付款資料
 * @param {Object} props.allowances - 折讓資料
 * @param {Object} props.dialogRef - 訂單彈窗引用
 * @param {Object} props.financeDialogRef - 財務彈窗引用（折讓證明審核）
 * @param {boolean} props.isUploadedCertificate - 是否已上傳折讓證明單
 * @param {string} props.confirmPath - 折讓證明單 PDF 路徑
 * @param {number} props.orderID - 訂單 ID
 * @param {number} props.orderReturnID - 退單 ID
 * @param {Function} props.refresh - 刷新回調
 * @returns {JSX.Element} 發票資訊區塊
 */
const OrderInvoiceInfoSection = ({ className, paymentData, allowances, dialogRef, financeDialogRef, isUploadedCertificate, confirmPath, orderID, orderReturnID, refresh }) => {
	const showReviewCertificateButton = isEqual(isUploadedCertificate, true);

	const handleOpenReviewCertificate = () => {
		if (!confirmPath) return;
		const openDialog = financeDialogRef?.current?.openReviewTriplicateAllowanceCertificateDialog;
		if (!isFunction(openDialog)) return;
		openDialog({ confirmPath, orderID, orderReturnID }, refresh);
	};

	return (
		<Card className={clsx("px-3 pt-2 pb-3", className)}>
			<Card.CardContent>
				<Stack direction="row" justifyContent="space-between" alignItems="center" className="mb-2">
					<Typography variant="body1">發票&折讓</Typography>
					{showReviewCertificateButton ? (
						<Button size="small" variant="outlined" onClick={handleOpenReviewCertificate} disabled={!confirmPath}>
							查看折讓證明單
						</Button>
					) : null}
				</Stack>
				<Grid container spacing={1}>
					<Grid item xs={6}>
						<ReadTextField label="發票號碼">{paymentData?.invoiceNo || "無相關資料"}</ReadTextField>
					</Grid>
					<Grid item xs={6}>
						<ReadTextField label="發票狀態">
							<Chip label={paymentData?.invoiceIntegrateStatusText} color={ORDER_STATUS_COLOR_MATCH[paymentData?.invoiceIntegrateStatusColor]} />
						</ReadTextField>
					</Grid>
				</Grid>
				<Divider className={"my-3"} />
				<Typography variant="body1" className={"mb-2"}>
					折讓資訊
				</Typography>
				{!isEmpty(allowances) ? (
					<>
						{allowances.map(item => (
							<InvoiceAllowanceCard key={item.allowanceID} sourceData={item} className={"mb-2"} dialogRef={dialogRef} refresh={refresh} />
						))}
					</>
				) : (
					<Box className={"font-color-3 pb-1"}>無折讓資訊</Box>
				)}
			</Card.CardContent>
		</Card>
	);
};
export default OrderInvoiceInfoSection;
